<template>
  <b-navbar class="navbar-bg">
    <!-- <b-navbar-brand> -->
      <router-link to="/">
        <div class="logo-atos">
          <img src="../assets/new-logo-ATOS-g .png" alt="Logo Site" style="width: 112px; height: 40px;">
        </div> 
      </router-link>
    <!-- </b-navbar-brand> -->

      <div class="navbar">
        <div class="nav-item">
          <router-link to="/">
            <span>A PLATAFORMA</span>
          </router-link>
        </div>
        
        <div class="nav-item" @click="showDialogContactMethod()" >
           
            <span>CONTATO</span>
          
        </div>
        
        <div class="nav-item">
          <router-link to="/faq">
            <span>FAQ</span>
          </router-link>
        </div>
<!-- 
        <div class="nav-item">
            <router-link to="/">
              <span>A PLATAFORMA</span>
            </router-link>
        </div> -->

        <div class="nav-item">
          <router-link to="/privacypolicy">
              <span>POLÍTICA DE PRIVACIDADE</span>
          </router-link>
        </div>

        <div class="nav-item">
          <router-link to="/termsofuse">
            <span>TERMOS DE USO</span>
          </router-link>
        </div>
      </div>
     
    
    <b-navbar-nav class="ml-auto">
      <template v-if="user.loggedIn">
        <b-nav-item-dropdown right class="userName">
          <template v-slot:button-content >
            <span style="padding:5px" class="linksHeader">{{ $t('hello')}} {{ user.data.displayName  | capitalize }}</span>
          </template>
         
          <template v-if="this.$store.state.privacyPolicyOk">
            <b-dropdown-item @click="showDialogKeywordsAlertsMethod()">
              <b-icon stacked icon="list" style="width: 18px; height: 18px;"></b-icon>
              {{$t('favorite_searchs')}}
            </b-dropdown-item> 
          
            <b-dropdown-divider></b-dropdown-divider>
          
            <b-dropdown-item @click="showDialogChangePwdMethod()">
              <b-icon icon="lock" style="width: 18px; height: 18px;"></b-icon>
              {{$t('change_password')}}
            </b-dropdown-item>
          
            <b-dropdown-item @click="showDialogDeleteAccountMethod()">
              <b-icon icon="trash" style="width: 18px; height: 18px;"></b-icon>
              {{$t('delete_account')}}
            </b-dropdown-item>

            <b-dropdown-divider></b-dropdown-divider>
          </template>
          <template v-else>
            <router-link to="/privacypolicy">  
              <div class="itemPolicyPrivacy">
                <b-icon icon="exclamation-circle" style="width: 18px; height: 18px;"></b-icon>
                {{$t('infoMsgpolicyPrivacyAgree')}}
              </div>
            </router-link>
              <!-- <b-dropdown-item style="width: 260px; background-color:#ffff9e">
                <b-icon icon="exclamation-circle" style="width: 18px; height: 18px;"></b-icon>
                {{$t('infoMsgpolicyPrivacyAgree')}}
              </b-dropdown-item> -->
              <b-dropdown-divider></b-dropdown-divider>
          </template>
          
         
         
          <b-dropdown-item  @click.prevent="signOut">
            <b-icon icon="door-open" style="width: 18px; height: 18px;"></b-icon>
            {{$t('logout')}}</b-dropdown-item>
        </b-nav-item-dropdown>
      </template>
      <template v-else>
        <div class="btn_log_in_out " @click="showDialogLoginMethod()">{{ $t('login')}}</div>
        
        <div class="btn_log_in_out " @click="showDialogSignUpMethod()">{{ $t('signup')}}</div>       
      </template>
    </b-navbar-nav>
    
    <!-- Popup LOGIN -->
    <md-dialog :md-active.sync="showDialogLogin" :md-click-outside-to-close="false">
      <login class="wrapper-dialog" v-on:showDialogLogin="closeDialogLogin()" v-on:showDialogForgotPassword="showDialogForgotPasswordMethod()"></login>
    </md-dialog>

    <!-- Popup CADASTRE-SE  -->
    <md-dialog hide-overlay :md-active.sync="showDialogSignUp" :md-click-outside-to-close="false">
      <signup class="wrapper-dialog" v-on:showDialogSignUp="closeDialogSignUp()"></signup>
    </md-dialog>

    <!-- Popup MUDAR SENHA  -->
    <md-dialog :md-active.sync="showDialogChangePwd" :md-click-outside-to-close="false">
      <changePwd class="wrapper-dialog" v-on:showDialogChangePwd="closeDialogChangePwd()" ></changePwd>
    </md-dialog>

    <!-- POPUP CADASTRAMENTO PALAVRAS CHAVE  -->
    <md-dialog :md-active.sync="showDialogKeywordsAlerts" class="dialog_theme_kwAlert" :md-click-outside-to-close="false" >
      <keywordsAlertList class="wrapper-dialog" v-on:showDialogKeywordsAlerts="closeDialogKeywordsAlerts()" ></keywordsAlertList>
    </md-dialog>

    <!-- POPUP ESQUECI MINHA SENHA  -->
    <md-dialog :md-active.sync="showDialogForgotPassword" :md-click-outside-to-close="false">
       <forgotPassword class="wrapper-dialog" v-on:showDialogForgotPassword="closeDialogForgotPassword()" ></forgotPassword>
    </md-dialog>

    <!-- POPUP CONTATO  -->
    <md-dialog :md-active.sync="showDialogContact" :md-click-outside-to-close="false">
       <contact class="wrapper-dialog" v-on:showDialogContact="closeDialogContact()" ></contact>
    </md-dialog>

    <!-- Popup MUDAR SENHA  -->
    <md-dialog :md-active.sync="showDialogDeleteAccount" :md-click-outside-to-close="false">
      <deleteAccount class="wrapper-dialog" v-on:showDialogDeleteAccount="closeDialogDeleteAccount()" ></deleteAccount>
    </md-dialog>


  </b-navbar>

</template>

<script>
import { mapGetters } from "vuex";
import firebase from '@/firebaseInit.js';
import login from '@/components/Login.vue'
import signup from '@/components/SignUp.vue'
import changePwd from '@/components/ChangePassword.vue'
import forgotPassword from '@/components/forgotPassword.vue'
import contact from '@/components/Contact.vue'
import deleteAccount from '@/components/DeleteAccount.vue'
import keywordsAlertList from '@/components/keywordsAlert/keywordsAlertList.vue'

import functionsSharedMixins from '@/shared/functionsSharedMixin';

export default {
  mixins: [functionsSharedMixins],
  components: { 
    login,
    signup,
    changePwd,
    forgotPassword,
    keywordsAlertList,
    contact,
    deleteAccount
  },
  
  computed: {
    ...mapGetters({
      user: "user"
    })
  },
  
  data() {
    return {
      email: "",
      senha: "",
      showDialogLogin: false,
      showDialogSignUp: false,
      showDialogChangePwd: false,
      showDialogForgotPassword:false,
      showDialogKeywordsAlerts: false,
      showDialogContact: false,
      showDialogDeleteAccount: false,
    };
  },

  methods:{
    signOut() {
      this.email = "",
      this.senha = "",

      firebase
        .auth()
        .signOut().then(() => {
          if(this.$route.path != "")
            this.$router.replace("/");
        });
    },

    useInSearch(value){
        this.$store.commit('setSearchedWords', value)
        this.showDialogKeywordsAlerts = false;
    },

    showDialogLoginMethod(){
      this.$store.commit('setFocusClass', 'focusClass')
      this.showDialogLogin = true;
      
    },
    
    closeDialogLogin(){
      this.$store.commit('setFocusClass', '')
      this.showDialogLogin = false;
    },

    showDialogSignUpMethod(){
      this.$store.commit('setFocusClass', 'focusClass')
      this.showDialogSignUp = true;
    },

    closeDialogSignUp(){
      this.$store.commit('setFocusClass', '')
      this.showDialogSignUp = false
    },

    showDialogChangePwdMethod(){
      this.$store.commit('setFocusClass', 'focusClass')
      this.showDialogChangePwd = true
    },

    closeDialogChangePwd(){
      this.$store.commit('setFocusClass', '')
      this.showDialogChangePwd = false
    },

    showDialogKeywordsAlertsMethod(){
      this.$store.commit('setFocusClass', 'focusClass')
      this.showDialogKeywordsAlerts = true;
    },

    closeDialogKeywordsAlerts(){
      this.$store.commit('setFocusClass', '')
      this.showDialogKeywordsAlerts = false;
    },
    
    showDialogForgotPasswordMethod(){
      this.showDialogLogin = false;
      this.showDialogForgotPassword = true;
    },

    closeDialogForgotPassword(){
      this.$store.commit('setFocusClass', '')
      this.showDialogForgotPassword = false;
    },

    showDialogContactMethod(){
      this.$store.commit('setFocusClass', 'focusClass')
      this.showDialogContact= true;
    },

    closeDialogContact(){
      this.$store.commit('setFocusClass', '')
      this.showDialogContact = false;
    },

    showDialogDeleteAccountMethod(){
      this.$store.commit('setFocusClass', 'focusClass')
      this.showDialogDeleteAccount = true
    },

    closeDialogDeleteAccount(){
      this.$store.commit('setFocusClass', '')
      this.showDialogDeleteAccount = false
    },

  }, 
  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  }
};
</script>

<style scoped lang="scss">
  $break-small: 420px;
  $break-large: 1200px;

    .logo-atos{
      height: 50px;
      width: 155px;
      //margin-right: 10px;
      margin-top: 10px;

      @media screen and (max-width: $break-small) {
        background:url('../assets/logo-atos-mobile.png') no-repeat;
        height: 50px;
        width: 48px;
      }
    }
  
    ::v-deep .userName{
      span{font-weight: 300 !important; &:hover{ color:#000 !important}}
      a:hover{ text-decoration: underline !important; }
      margin-right: 5px;
    }

    .navbar-bg {
      background-color: #e8e8e82e;
      border-bottom: 1px solid #cac9c92e;
      padding: 0 10px;
      
      ::v-deep .nav-link { color: #000000 !important; padding: 2px !important; 
      a{ color: #000000 !important; 
      @media screen and (max-width: $break-small) { padding: 0;}}  }
      ::v-deep .dropdown-menu { 
          border: none;
          a{color:#000;
           text-decoration: none !important;
            &:hover{color:#fff}
          }
          background-color: #fff; 
          filter: drop-shadow( 1px 1px 2px rgba(0, 0, 0, .2));
      }
      ::v-deep .dropdown-item { 
        a{color:#000;}
        &:hover{background-color: #2a4579b7;
           a{color:#fff; }}
        }

      ::v-deep .btn_log_in_out{
        font-size: 14px;
        padding: 5px;
        a{ &:hover{color:#1937a0 !important;}}
        &:hover{
          color:#1937a0 !important;
          cursor: pointer;
        }
      }

      ::v-deep .nav-link span{
        padding:5px;
        font-weight: 600;
        &:hover{
          color:#1937A0;
          
        }
      }
    }
    
    .navbar-brand {
      a {padding: 0;}
    }

    .nav-item{
      margin-right: 5px;
    }


    .linksHeader{
      font-weight:bold 500 !important;
      font-size: 14px;
      @media screen and (max-width: $break-small) {
        font-size: 12px;
        
      }
    }

    .itemPolicyPrivacy{
      width: 260px; 
      background-color:#ffff9e; 
      padding: 0.25rem 1.5rem;
      color:#000;
      
    }
    .router-link-active{
     
      .itemPolicyPrivacy:hover{
         color:#fff; 
         background-color:#2a4579b7; 
         
      }
    }

    .navbar {
      display: flex;
      @media (max-width: 1024px) {
        flex-direction: column;
        .logo-atos {
          background: url('../assets/logo-ATOS-g.png') no-repeat;
          width: 95px;
          margin-top: 40px;
        }
      }
      gap: 20px;
      .nav-item {
        a { color: #000 !important;  }
        font-size: 14px;        
        cursor: pointer;
        span:hover {
          color: #1937a0;
        }
      }
      
    }

</style>